import React, { useEffect, useState } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ViewSoModal from "../../../components/Modal/ViewSoModal";
import PrintInvoiceModal from "../../../components/Modal/PrintInvoiceModal";
import moment from "moment";
import { formatDate, formatThaiDateUi } from "../../../../utils/DateUtils";
import {
  getData,
  formatCurrency,
  parseCurrency,
} from "../../../../utils/SamuiUtils";
import { getReport } from "../../../../utils/ReportUtils";
import Swal from "sweetalert2";
const SUMMARY_FIELDS = [
  {
    key: "Doc_INV_No",
    label: "เลขใบเสร็จรับเงิน",
    w: "10%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "Doc_SO_Receive_Date",
    label: "วันที่ใบเสร็จรับเงิน",
    w: "10%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "Doc_No",
    label: "เอกสารอ้างอิง",
    w: "10%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "Doc_Date",
    label: "วันที่เอกสารอ้างอิง",
    w: "10%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "Doc_Status",
    label: "สถานะ",
    w: "10%",
    alignHeader: "center",
    align: "center",
    sortable: false,
    customRender: "status",
  },
  {
    key: "DocStatusPaid_Type_Name",
    label: "ประเภทการจ่าย",
    w: "10%",
    alignHeader: "center",
    align: "center",
    sortable: false,
    customRender: "paymentType",
  },
  {
    key: "AR_Code",
    label: "รหัสลูกค้า",
    w: "7%",
    alignHeader: "left",
    align: "center",
    sortable: true,
  },
  {
    key: "AR_Name",
    label: "ชื่อลูกค้า",
    w: "22%",
    alignHeader: "left",
    align: "left",
    sortable: true,
  },
  {
    key: "NetTotal",
    label: "รวมราคา",
    w: "8%",
    alignHeader: "center",
    align: "end",
    numeric: true,
    sortable: true,
  },
  {
    key: "edit",
    label: "",
    w: "1%",
    alignHeader: "center",
    align: "center",
    customRender: "edit",
  },
  {
    key: "print",
    label: "",
    w: "1%",
    alignHeader: "center",
    align: "center",
    customRender: "print",
  },
];
const Main = ({ name, dataMasterList, onPageInsert, onPageUpdate }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [docNo, setDocNo] = useState("");
  const [arName, setArName] = useState("");
  const [soTotal, setSoTotal] = useState(0);
  const [soTotalVat, setSoTotalVat] = useState(0);
  const [soNetTotal, setSoNetTotal] = useState(0);
  const [sortedData, setSortedData] = useState([]);
  const [searchItemTerm, setSearchItemTerm] = useState("");
  const [sortField, setSortField] = useState("Doc_INV_No");
  const [sortOrder, setSortOrder] = useState("desc");

  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const matchesItemSearchTerm =
      data.Doc_No.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
      data.Doc_INV_No.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
      data.AR_Name.toLowerCase().includes(searchItemTerm.toLowerCase());

    return matchesItemSearchTerm;
  });

  useEffect(() => {
    if (dataMasterList && dataMasterList.length > 0) {
      const filtered = dataMasterList.filter((data) =>
        data.Doc_No.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
        data.Doc_INV_No.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
        data.AR_Name.toLowerCase().includes(searchItemTerm.toLowerCase())
      );
      sortData(filtered);
    }
  }, [dataMasterList, searchItemTerm]);

  const [showOptionInvModal, setShowOptionInvModal] = useState(false);
  const [selectBiNo, setSelectBiNo] = useState(null);
  const [selectInvNo, setSelectInvNo] = useState(null);
  //  ทำ sort โดยนำเลขที่ใบเสร็จรับเงินมาเรียงลำดับ
  const sortData = (data, field = sortField, order = sortOrder) => {
    const sorted = [...data].sort((a, b) => {
      const aValue = a[field];
      const bValue = b[field];

      if (field === "Doc_Date") {
        return order === "asc"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }

      if (typeof aValue === "number" || typeof bValue === "number") {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }

      return order === "asc"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });

    setSortedData(sorted);
  };

  const handleSort = (fieldKey) => {
    const newOrder = fieldKey === sortField && sortOrder === "asc" ? "desc" : "asc";
    setSortField(fieldKey);
    setSortOrder(newOrder);
    sortData(filteredItemData, fieldKey, newOrder);
  };
  useEffect(() => {
    sortData(filteredItemData);
  }, [sortField, sortOrder, searchItemTerm]);

  return (
    <>
      <Breadcrumbs
        page={name}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/receipt" },
        ]}
      />
      <div
        className="container-fluid card py-3 hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="row mb-2 align-items-center">
          <div className="col-1">
            <button
              className="btn text-white mx-3"
              onClick={() => onPageInsert()}
              style={{
                backgroundColor: "rgb(239, 108, 0)",
                whiteSpace: "nowrap",
                padding: "10px",
                fontSize: "15px",
              }}
            >
              <i className="fa fa-plus" aria-hidden="true"></i> {name}
            </button>
          </div>
          <div className="col-4">
            <div className="input-group">
              <span className="input-group-text">Search</span>
              <input
                type="text"
                className="form-control"
                value={searchItemTerm}
                onChange={(e) => setSearchItemTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-7"></div>
        </div>
        <hr />
        <div className="row">
          <div
            className=" mb-1"
            style={{ borderRight: "2px solid #c7c8c9" }}
          >
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
              >
                <thead className="thead-dark">
                  <tr>
                    {SUMMARY_FIELDS.map((field) => (
                      <th
                        key={field.key}
                        className={`text-${field.alignHeader} ${field.sortable ? "cursor-pointer" : ""}`}
                        style={{ width: field.w }}
                        onClick={() => field.sortable && handleSort(field.key)}
                      >
                        {field.label}
                        {field.sortable && (
                          <span className="ms-1">
                            {sortField === field.key ? (
                              sortOrder === "asc" ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>
                            ) : (
                              <i className="fas fa-sort text-muted"></i>
                            )}
                          </span>
                        )}
                      </th>

                    ))}
                  </tr>
                </thead>

                <tbody>
                  {sortedData.length > 0 ? (
                    sortedData.map((data, index) => (
                      <tr
                        key={data.Doc_Id || index}
                        style={{
                          cursor: "pointer",
                          backgroundColor: data.Doc_No === docNo ? "rgb(105, 188, 216)" : "transparent",
                        }}
                      >
                        {SUMMARY_FIELDS.map((field) => {
                          const value = data[field.key];

                          if (field.customRender === "edit") {
                            return (
                              <td key={field.key} className="text-center">
                                <button className="btn btn-sm" onClick={() => onPageUpdate(data.Doc_INV_No)}>
                                  <i className="fa fa-edit" />
                                </button>
                              </td>
                            );
                          }

                          if (field.customRender === "print") {
                            return (
                              <td key={field.key} className="text-center">
                                <i
                                  className="fa fa-print"
                                  style={{ fontSize: "16px", color: "#2196F3" }}
                                  onClick={() => {
                                    Swal.fire({
                                      title: "พิมพ์ใบเสร็จรับเงิน",
                                      text: `เลขที่ใบเสร็จรับเงิน: ${data.Doc_INV_No}`,
                                      icon: "info",
                                      showCancelButton: true,
                                      confirmButtonText: "พิมพ์",
                                      cancelButtonText: "ยกเลิก",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        const reportType = data.Doc_No.startsWith("BI") ? "INV_RECEIPT" : "so_receipt";
                                        getReport(reportType, data.Doc_No);
                                      }
                                    });
                                  }}
                                />
                              </td>
                            );
                          }

                          if (field.customRender === "status") {
                            return (
                              <td key={field.key} className="text-center">
                                <button
                                  className="btn"
                                  style={{
                                    backgroundColor: data.Doc_Status !== 13 ? data.DocStatusPaid_Colour : "black",
                                    color: "white",
                                    width: "100%",
                                  }}
                                >
                                  {data.Doc_Status !== 13 ? data.DocStatusPaid_Name : "ยกเลิก"}
                                </button>
                              </td>
                            );
                          }

                          if (field.customRender === "paymentType") {
                            return (
                              <td key={field.key} className="text-center">
                                {data.DocStatusPaid_Name !== "จ่ายครบ" ? (
                                  "-"
                                ) : (
                                  <button
                                    className="btn"
                                    style={{
                                      backgroundColor: data.DocStatusPaidType_Colour,
                                      color: "white",
                                      width: "100%",
                                    }}
                                  >
                                    {data.DocStatusPaid_Type_Name}
                                  </button>
                                )}
                              </td>
                            );
                          }

                          return (
                            <td key={field.key} className={`text-${field.align}`}>
                              {field.key === "Doc_Date"
                                ? formatThaiDateUi(value)
                                : field.key === "Doc_SO_Receive_Date"
                                  // แปลงเป็น พศ
                                  ? moment.utc(value).format("DD-MM-") + (moment.utc(value).year() + 543)
                                  : field.key === "NetTotal"
                                    ? formatCurrency(parseCurrency(value))
                                    : value}

                            </td>
                          );
                        })}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={SUMMARY_FIELDS.length}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>

                {filteredItemData.length > 0 && (
                  <tfoot>
                    <tr>
                      <td
                        colSpan="11"
                        className="text-end"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        <div className="row">
                          {/* รวม */}
                          <div className="col-12">
                            <span>รวมยอด วางบิล</span>
                            <span
                              style={{ paddingLeft: "10px", color: "#EF6C00" }}
                            >
                              {formatCurrency(
                                filteredItemData.reduce(
                                  (acc, item) => acc + parseCurrency(item.NetTotal || 0),
                                  0
                                )
                              )}
                            </span>
                            <span style={{ paddingLeft: "10px" }}>บาท</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Main;
